import { SvelteComponent, init, safe_not_equal, element, space, create_component, attr, insert, append, mount_component, transition_in, transition_out, detach, destroy_component, component_subscribe, text, noop } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../i18n.js';
import tsv from '../../store/tsv.js';
import { openUrl } from '../../utils/openUrl.js';
import Button from '../shared/components/Button/Button.svelte.js';
import { ButtonTheme } from '../../interfaces/ButtonTheme.js';
import './TwoFactorDisabled.css.js';

/* src/ui/PurchaseProduct/TwoFactorDisabled.svelte generated by Svelte v3.44.2 */

function create_default_slot(ctx) {
	let t_1_value = t('Настроить защиту') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

function create_fragment(ctx) {
	let div0;
	let t1;
	let div2;
	let div1;
	let t3;
	let button;
	let current;

	button = new Button({
			props: {
				theme: ButtonTheme.secondary,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*openTwoFactorSettings*/ ctx[0]);

	return {
		c() {
			div0 = element("div");
			div0.textContent = `${t('Для завершения покупки необходимо настроить защиту платежных операций в открывшемся окне браузера.')}`;
			t1 = space();
			div2 = element("div");
			div1 = element("div");
			div1.textContent = `${t('Если окно браузера не открылось или выслучайно его закрыли, то нажмите на кнопку ниже.')}`;
			t3 = space();
			create_component(button.$$.fragment);
			attr(div0, "class", "secure-description wcl-rdv9ah");
			attr(div1, "class", "secure-hint wcl-rdv9ah");
			attr(div2, "class", "secure-action wcl-rdv9ah");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			insert(target, div2, anchor);
			append(div2, div1);
			append(div2, t3);
			mount_component(button, div2, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 4) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			if (detaching) detach(div2);
			destroy_component(button);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $tsv;
	component_subscribe($$self, tsv, $$value => $$invalidate(1, $tsv = $$value));

	function openTwoFactorSettings() {
		openUrl($tsv.managementUrl);
	}

	return [openTwoFactorSettings];
}

class TwoFactorDisabled extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export { TwoFactorDisabled as default };
//# sourceMappingURL=TwoFactorDisabled.svelte.js.map
